export const SettingsContainer = () => {
    return (
        <span>Settings placeholder</span>
    );
};